import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/itoken/management/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'iToken Management',
    meta: {
      title: '@iToken.iTokenManagement.title',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.itoken,
      icon: 'app:nav-itoken',
    },
    children: [
      {
        path: MODULE_PATH + 'campaign/list',
        component: load('application/itoken/campaign/CampaignList'),
        name: 'iToken Campaign List',
        meta: {
          title: '@campaign.campaignList.title',
          menuItem: true,
          sorting: 5001,
        },
      },
      {
        path: MODULE_PATH + 'campaign/new',
        component: load('application/itoken/campaign/CampaignArea'),
        name: 'iToken Campaign New',
        meta: {
          title: '@campaign.createCampaign.title',
          menuItem: false,
          sorting: 5001,
        },
      },
      {
        path: MODULE_PATH + 'campaign/view/[:campaignID]',
        component: load('application/itoken/campaign/CampaignArea'),
        name: 'iToken Campaign Details',
        props: true,
        meta: {
          title: '@campaign.updateCampaign.title',
          menuItem: false,
          sorting: 5001,
        },
      },
      {
        path: MODULE_PATH + 'voucher/list',
        component: load('application/itoken/voucher/iTokenVoucherList'),
        name: 'iToken Voucher List',
        meta: {
          title: '@voucher.listing.title',
          menuItem: true,
          sorting: 5002,
        },
      },
      {
        path: MODULE_PATH + 'voucher/new/[:memberID]/[:campaignID]/[:campaignName]',
        component: load('application/itoken/voucher/iTokenVoucherArea'),
        name: 'iToken Voucher New',
        props: true,
        meta: {
          title: '@voucher.newVoucher.title',
          menuItem: false,
          sorting: 5002,
        },
      },
      {
        path: MODULE_PATH + 'voucher/view/[:voucherID]',
        component: load('application/itoken/voucher/iTokenVoucherArea'),
        name: 'iToken Voucher View',
        props: true,
        meta: {
          title: '@voucher.viewVoucher.title',
          menuItem: false,
          sorting: 5002,
        },
      },
      {
        path: MODULE_PATH + 'redemption/list',
        component: load('application/itoken/redemption/RedemptionList'),
        name: 'iToken Redemption List',
        meta: {
          title: '@redemption.redemptionList.title',
          menuItem: true,
          sorting: 5003,
        },
      },
      {
        path: MODULE_PATH + 'redemption/new',
        component: load('application/itoken/redemption/RedemptionArea'),
        name: 'iToken Redemption New',
        meta: {
          title: '@redemption.createRedemption.title',
          menuItem: false,
          sorting: 5003,
        },
      },
      {
        path: MODULE_PATH + 'redemption/view/[:redemptionID]',
        component: load('application/itoken/redemption/RedemptionArea'),
        name: 'iToken Redemption Details',
        props: true,
        meta: {
          title: '@redemption.updateRedemption.title',
          menuItem: false,
          sorting: 5003,
        },
      },
    ],
  },
]
